/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { ReactComponent as Spinner } from 'static/icons/spinner.svg';
import { COLORS } from 'colors';

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 70vh;
`;

export const StyledSpinner = styled(Spinner)`
  animation: spin 1s linear infinite;
  height: 5rem;
  width: 5rem; 
  fill: ${COLORS.PRIMARY}; 
`;
